import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import ReportAnswerPercentage from '../../../../incase-domain/components/report/answer/ReportAnswerPercentage';
import {IQuestionElements} from '../../../../incase-domain/elements/question';
import {ISlide} from '../../../../incase-domain/slide';
import {getAnswerStatus} from './utils';
import {ELEMENT, interactiveElementTypes} from '../../../../incase-domain/elements/base/ElementTypes';
import {getAnswers} from '../../../slides/highlighted/questionReport/utils';

interface IQuestionReportElementProps {
    question: IQuestionElements;
    slide: ISlide | undefined;
}

const DUMMY_YES_ANSWERS = 100;
const DUMMY_NO_ANSWERS = 300;
const DUMMY_TOTAL_ANSWERS = DUMMY_YES_ANSWERS + DUMMY_NO_ANSWERS;
const YES_PERCENTAGE = 25;
const NO_PERCENTAGE = 75;

function DummyQuestionReport({question, slide}: IQuestionReportElementProps): JSX.Element {
    const {t} = useTranslation();

    const dummyReport = useMemo(
        () =>
            question && interactiveElementTypes.includes(question.type)
                ? {
                      elementId: question.id,
                      question: question.question,
                      answers: getAnswers(question),
                      slide: {
                          id: slide?._id || '',
                          name: slide?.name || '',
                      },
                      totalAnswers: DUMMY_TOTAL_ANSWERS,
                      type: question.type,
                  }
                : {
                      elementId: '',
                      question: t('reportElement.title'),
                      type: ELEMENT.QUESTION,
                      answers: [
                          {
                              answerText: t('reportElement.yes'),
                              noOfAnswers: DUMMY_YES_ANSWERS,
                              isCorrect: true,
                              percentage: YES_PERCENTAGE,
                          },
                          {
                              answerText: t('reportElement.no'),
                              noOfAnswers: DUMMY_NO_ANSWERS,
                              isCorrect: false,
                              percentage: NO_PERCENTAGE,
                          },
                      ],
                      slide: {id: '', name: ''},
                      totalAnswers: DUMMY_TOTAL_ANSWERS,
                  },
        [question, slide, t]
    );

    return (
        <div className="c-questionReport__answers">
            {dummyReport.answers.map((answer, index) => (
                <div className="c-questionReport__answers-item" key={index}>
                    <ReportAnswerPercentage
                        label={answer.answerText}
                        percentage={answer.percentage}
                        type={getAnswerStatus(question, answer.answerText)}
                        showCorrect
                        isPresenter
                    />
                </div>
            ))}
        </div>
    );
}

export default DummyQuestionReport;
